<template>
  <Tabs :value="tabactive" :lazy="true">
    <TabList>
      <Tab v-for="tab in tabs" :key="tab.key" :value="tab.key">{{ tab.title }}
        <span v-if="getTabCount(tab.key) > 0" class="count-result">
          {{ formatCount(getTabCount(tab.key)) }}
        </span>
      </Tab>
    </TabList>
    <TabPanels>
      <TabPanel v-for="tab in tabs" :key="tab.key" :value="tab.key">
        <slot :name="tab.key"></slot>
      </TabPanel>
    </TabPanels>
  </Tabs>
</template>
<script>

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import {defineComponent} from 'vue';

export default defineComponent({
  name: "TabsDettaglio",
  props: {
    'tabactive': String,
    'tabs': Array,
    'counts': {
      type: Object,
      default: () => ({})
    },
    'datiGrafico': {
      type: Array,
      default: () => []
    }
  },

  components: {
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel
  },
  data() {
    return {
      loadedTabs: [this.tabactive],
      localCounts: {}
    }
  },
  methods: {
    formatCount(count) {
      return count > 999 ? '999+' : count.toString();
    },
    getTabCount(tabKey) {
      return this.counts[tabKey] || 0;
    }
  }
});
</script>
<style scoped>

</style>